import { Box, Chip, Grid } from "@mui/material";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import { getDateWithoutSeconds } from "../../utils/getDateWithoutSeconds";
import { eventCategoriesAr } from "../../utils/translations";
import { translator } from "../../utils/translations/translator";
import ImageList from "../ImageList";
import Info from "../Info";
import Map from "../Map";
import Title from "../Title";

type IProps = {
  event: any;
};

const Single: React.FC<IProps> = ({ event }) => {
  const { isRTL } = useRTL();
  const { general, pages } = useContent();
  const { events } = pages;

  return (
    <>
      <Title title={`${events.event} - ${event.title}`} />
      <Grid container spacing={2}>
        <Grid container item>
          <Grid item xs={12}>
            <Info title={events.eventGeneralInfo} isSectionTitle />
          </Grid>

          <Grid item xs={12}>
            <Info title={events.onlyForTenants} description={event.onlyForTenants ? general.yes : general.no} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Info title={events.details} description={event.details} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Info
              title={events.category}
              description={
                isRTL
                  ? translator(event.category, eventCategoriesAr)
                  : event.category
              }
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Info
              title={events.partnerCode}
              description={event.partnerCode || "-"}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Info
              title={events.loyaltyCategory}
              description={event.loyaltyCategory}
            />
          </Grid>

          <Grid item xs={12}>
            <Info title={events.website} description={event.website || "-"} />
          </Grid>

          <Grid item xs={12} sx={{ mb: 2 }}>
            <Info
              title={events.prices}
              description={event.prices.length ? undefined : "-"}
            />
            <Box sx={{ display: "flex" }}>
              {event.prices.map((price: any) => (
                <Chip
                  key={price.title}
                  sx={{ mr: 1 }}
                  label={`${price.title}: ${price.price}`}
                  color="primary"
                />
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Info
              title={events.publishDate}
              description={`${getDateWithoutSeconds(event.publishDate)}`}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Info
              title={events.startDate}
              description={`${getDateWithoutSeconds(event.startDate)}`}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Info
              title={events.endDate}
              description={`${getDateWithoutSeconds(event.endDate)}`}
            />
          </Grid>
        </Grid>

        <Grid container item>
          <Grid item xs={12}>
            <Info title={events.eventLocation} isSectionTitle />
          </Grid>

          <Grid item xs={12}>
            <Map
              center={{ lat: event.latitude, lng: event.longitude }}
              zoom={10}
              sx={{ height: "400px" }}
              draggable={false}
              markers={[
                {
                  pos: { lat: event.latitude, lng: event.longitude },
                },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Info title={events.lat} description={event.latitude} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Info title={events.lng} description={event.longitude} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Info
              title={events.poi}
              isLink={!!event.POI}
              description={event.POI || "-"}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sx={{ mb: 2 }}>
          <Info
            title={events.parking}
            description={event.parking.length ? undefined : "-"}
          />
          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            {event.parking.map((parking: any, index: number) => (
              <Chip
                key={index}
                sx={{ mr: 1, mb: 1 }}
                label={parking}
                color="primary"
              />
            ))}
          </Box>
        </Grid>

        <Grid container item>
          <Grid item xs={12}>
            <Info title={events.eventImages} isSectionTitle />
          </Grid>

          <Grid item xs={12} md={6}>
            <Info title={events.logo} />
            <ImageList images={event.logo ? [event.logo] : []} />
          </Grid>

          <Grid item xs={12} md={6}>
            <Info title={events.heroImage} />
            <ImageList images={event.heroImage ? [event.heroImage] : []} />
          </Grid>

          <Grid item xs={12}>
            <Info title={events.images} />
            <ImageList images={event.images} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Single;
